<script setup lang="ts">
import fenziTest from '@/components/fenziTest.vue'
import ParticleStar from '@/components/ParticleStar.vue'
// import Halo from '@/components/halo.vue'
// import ParticleTerrain from '@/components/ParticleTerrain.vue'

import history1 from '~/assets/images/home_history_img1.png'
import history2 from '~/assets/images/home_history_img2.png'
import history3 from '~/assets/images/home_history_img3.png'
import history4 from '~/assets/images/home_history_img4.png'
import history5 from '~/assets/images/home_history_img5.png'
import history6 from '~/assets/images/home_history_img6.png'
import history7 from '~/assets/images/home_history_img7.png'
// import ParticleRingScene from '@/components/ParticleRingScene.vue'
import { vLazyVideo } from '@/composables/useLazyVideo'
const { trackEvent } = useCnzz()

const { t, tm, rt } = useI18n()
useHead({
  title: t('welcome.title'),
})

// 粒子特效hover状态
const isParticleHovering = ref(false)

// fenziTest 组件引用 - web端和移动端分开
const fenziTestRef = ref<InstanceType<typeof fenziTest> | null>(null)
const fenziTestRefMobile = ref<InstanceType<typeof fenziTest> | null>(null)

// 粒子hover状态变化回调
const onParticleHoverChange = (hovering: boolean) => {
  isParticleHovering.value = hovering
}

// Data for Ecosystem Section
const solutions = computed(() => [
  {
    title: t('home.solutions.biopharmaceutical.title'),
    icon: 'https://images-cloud.qboson.com/website/shengwu-icon.png',
    iconColor: 'text-teal-400',
    link: '/biopharmaceutical',
    desc: t('home.solutions.biopharmaceutical.desc'),
    btnText: t('home.solutions.biopharmaceutical.btnText'),
  },
  {
    title: t('home.solutions.ai.title'),
    icon: 'https://images-cloud.qboson.com/website/ai-icon.png',
    iconColor: 'text-blue-500',
    link: '/AI',
    desc: t('home.solutions.ai.desc'),
    btnText: t('home.solutions.ai.btnText'),
  },
  {
    title: t('home.solutions.city.title'),
    icon: 'https://images-cloud.qboson.com/website/city-icon.png',
    iconColor: 'text-cyan-500',
    link: '/city',
    desc: t('home.solutions.city.desc'),
    btnText: t('home.solutions.city.btnText'),
  },
])

// Data for Products Section
const products = computed(() => [
  {
    title: t('home.products.items.computer.title'),
    desc: t('home.products.items.computer.desc'),
    link: '/product/product1000bit',
    img: 'https://images-cloud.qboson.com/website/5.png',
    target: '',
  },
  {
    title: t('home.products.items.competition.title'),
    desc: t('home.products.items.competition.desc'),
    link: 'https://kaiwu.qboson.com/plugin.php?id=crowdsourcing&modac=qdIndex&modacPage=taskList',
    img: 'https://images-cloud.qboson.com/website/1.png',
    target: '_blank',
  },
  {
    title: t('home.products.items.community.title'),
    desc: t('home.products.items.community.desc'),
    link: 'https://kaiwu.qboson.com/',
    img: 'https://images-cloud.qboson.com/website/22.png',
    target: '_blank',
  },
  {
    title: t('home.products.items.sdk.title'),
    desc: t('home.products.items.sdk.desc'),
    link: 'https://github.com/qboson/kaiwu-pytorch-plugin',
    img: 'https://images-cloud.qboson.com/website/3.png',
    target: '_blank',
  },
  {
    title: t('home.products.items.cloud.title'),
    desc: t('home.products.items.cloud.desc'),
    link: 'https://platform.qboson.com/',
    img: 'https://images-cloud.qboson.com/website/3-cloud.png',
    target: '_blank',
  },
])

// Data for Hero Section Links
const heroLinks = computed(() => [
  {
    title: 'QBoson',
    href: '#',
    action: 'circle', // 点击切换到粒子圆圈
  },
  {
    title: t('home.hero.links.quantumBio'),
    href: '#',
    action: 'molecule', // 点击切换到分子形状
  },
  {
    title: t('home.hero.links.quantumAI'),
    href: '#',
    action: 'ai', // 点击切换到AI球体
  },
  {
    title: t('home.hero.links.quantumCity'),
    href: '#',
    action: 'city', // 点击切换到城市形状
  },
])

// 处理 hero link 点击
const handleHeroLinkClick = (
  action: string | null,
  event: Event,
  index?: number,
) => {
  if (index !== undefined) {
    selectedHeroIndex.value = index
  }
  event.preventDefault()

  // 使用统一的切换函数
  if (action === 'circle') {
    fenziTestRef.value?.switchTo('circle')
  } else if (action === 'molecule') {
    fenziTestRef.value?.switchTo('molecule')
  } else if (action === 'ai') {
    fenziTestRef.value?.switchTo('ai')
  } else if (action === 'city') {
    fenziTestRef.value?.switchTo('city')
  }
}

// Data for Roadmap Section
const milestones = [
  {
    year: '2019',
    title: 'BEYOND CLASSICAL',
    subtitle: 'MILESTONE 1',
    tech: 'Physical Qubits: 54',
  },
  {
    year: '2023',
    title: 'QUANTUM ERROR CORRECTION',
    subtitle: 'MILESTONE 2',
    tech: 'Physical Qubits: 10^3',
    active: true,
  },
  {
    year: '',
    title: 'BUILDING A LONG-LIVED LOGICAL QUBIT',
    subtitle: 'MILESTONE 3',
    tech: 'Physical Qubits: 10^4',
  },
  {
    year: '',
    title: 'CREATING A LOGICAL GATE',
    subtitle: 'MILESTONE 4',
    tech: 'Physical Qubits: 10^4',
  },
  {
    year: '',
    title: 'ENGINEERING SCALE UP',
    subtitle: 'MILESTONE 5',
    tech: 'Physical Qubits: 10^5',
  },
  {
    year: '',
    title: 'LARGE ERROR-CORRECTED QUANTUM COMPUTER',
    subtitle: 'MILESTONE 6',
    tech: 'Physical Qubits: 10^6',
  },
]

// 路线图数据（从国际化文件读取 + 图片映射）
const roadmapImages = [
  history1,
  history2,
  history3,
  history4,
  history5,
  history6,
  history7,
]

const roadmapItems = computed(() => {
  const items = tm('home.roadmap.items') as any[]
  if (!Array.isArray(items)) return []
  return items.map((item: any, index: number) => ({
    title: rt(item.title),
    descriptions: Array.isArray(item.descriptions)
      ? item.descriptions.map((desc: any) => rt(desc))
      : [],
    year: rt(item.year),
    img: roadmapImages[index],
  }))
})

// 悬停状态管理
const hoveredColumnIndex = ref<number | null>(null)

// 路线图拖拽滚动
const roadmapScrollRef = useDragScroll(1.5)

// 移动端头部描述展开/收起状态
const isHeroDescExpanded = ref(false)

// 移动端头部圆点选中状态 (0, 1, 2)
const selectedDotIndex = ref(0)

// web端 hero 链接选中状态 (0 表示默认选中 Qboson)
const selectedHeroIndex = ref(0)

// SDK 调用量统计
const FALLBACK_SUCCESS_RATE = 100

const parseTotalCount = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}

const { getSdkTotalStatistics } = useNewsApi()
const {
  data: sdkTotalStatistics,
  pending: sdkTotalStatisticsPending,
  error: sdkTotalStatisticsError,
  refresh: refreshSdkTotalStatistics,
} = await getSdkTotalStatistics({
  server: false,
  immediate: true,
})

const source = ref(0)
const taskSource = ref(0)

const applySdkTotalCount = (res: typeof sdkTotalStatistics.value) => {
  if (!res) return

  const isSuccess = res.code === '0' || res.code === 0
  if (!isSuccess) return

  const count = parseTotalCount(res.data?.total_count)
  if (count !== null) {
    source.value = count
  }
}

// useTransition 依赖 requestAnimationFrame，SSR 阶段不可用
let outputValue: Ref<number>
let taskValue: Ref<number>

if (import.meta.client) {
  outputValue = useTransition(source, {
    duration: 1500,
  })
  taskValue = useTransition(taskSource, {
    duration: 1500,
  })

  watch(sdkTotalStatistics, (res) => {
    applySdkTotalCount(res)
  })

  // 等 transition 初始化并完成首帧渲染后再赋值，否则 watch 可能错过已返回的数据且同 tick 赋值不会触发动画
  nextTick(() => {
    applySdkTotalCount(sdkTotalStatistics.value)
    taskSource.value = FALLBACK_SUCCESS_RATE
  })
} else {
  outputValue = ref(0)
  taskValue = ref(FALLBACK_SUCCESS_RATE)
}

const valueStyle = ref({
  fontSize: '70px',
  fontWeight: 'bold',
})

const mobileValueStyle = ref({
  fontSize: '40px',
  fontWeight: '700',
})

// 确保在客户端挂载时触发 SDK 统计请求（首页预渲染场景下避免 SSR 取数失败）
onMounted(() => {
  nextTick(async () => {
    if (!sdkTotalStatistics.value && !sdkTotalStatisticsPending.value) {
      await refreshSdkTotalStatistics()
    }
    applySdkTotalCount(sdkTotalStatistics.value)
  })
})

// 控制显示哪个组件
const showCity = ref(false)

// 分子点击后的回调（现在不需要切换组件了）
const onMoleculeClick = () => {
  // 城市转场现在在 fenziTest 内部处理
}

// 处理移动端圆点点击（与 web 端 heroLinks 点击事件一致）
const handleDotClick = (index: number) => {
  selectedDotIndex.value = index
  const link = heroLinks.value[index]

  // 使用统一的切换函数
  if (link.action === 'circle') {
    fenziTestRefMobile.value?.switchTo('circle')
  } else if (link.action === 'molecule') {
    fenziTestRefMobile.value?.switchTo('molecule')
  } else if (link.action === 'ai') {
    fenziTestRefMobile.value?.switchTo('ai')
  } else if (link.action === 'city') {
    fenziTestRefMobile.value?.switchTo('city')
  }
}

// 以实用引领量子计算-友盟上报
const clickAbout = () => {
  trackEvent('首页-以实用引领量子计算', '点击', '了解我们按钮')
}

// 量子解决方案-友盟上报
const clickSolutions = (item: any) => {
  trackEvent(`首页-量子解决方案-${item.title}`, '点击', '案例详情按钮')
}

// 产品集合 - 友盟上报
const trackEventProducts = (item: any) => {
  trackEvent(`首页-产品集合-${item.title}`, '点击', '了解更多按钮')
}

// 滚动到关于我们
const scrollToAbout = () => {
  const element = document.getElementById('about-us')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <div class="min-h-screen w-full bg-[#F9FBFF] m-auto">
    <!-- web端 -->
    <div class="hidden md:block">
      <!-- 头部 -->
      <section
        class="relative h-[720px] bg-white md:pt-[150px] w-full overflow-hidden"
      >
        <!-- 粒子动效 - 作为背景铺满整个区域 -->
        <div class="absolute inset-0 w-full h-full">
          <ClientOnly>
            <fenziTest
              ref="fenziTestRef"
              :disable-internal-click="true"
              @molecule-click="onMoleculeClick"
              @hover-change="onParticleHoverChange"
            />
          </ClientOnly>
        </div>

        <div
          class="max-w-[1280px] h-full mx-auto relative z-10 pointer-events-none"
        >
          <div class="flex items-start justify-between">
            <div class="z-10 pointer-events-auto relative">
              <!-- 左侧文字蒙层 -->
              <!-- <div
                v-if="isParticleHovering"
                class="absolute inset-0 bg-white/70 rounded-lg transition-opacity duration-300 pointer-events-none"
              ></div> -->
              <div
                class="mb-[40px] md:text-4xl font-medium text-[#000]"
                :class="isParticleHovering ? 'opacity-[0.4]' : ''"
              >
                <p>{{ t('home.hero.title1') }}</p>
                <p class="mt-[10px]">{{ t('home.hero.title2') }}</p>
              </div>
              <p
                class="w-[326px] mb-[100px] text-[16px] text-[#2B79A1] text-justify"
                :class="isParticleHovering ? 'opacity-[0.4]' : ''"
              >
                {{ t('home.hero.description') }}
              </p>
              <NuxtLink
                :to="`/about`"
                class="bg-[#FFFFFF99] md:bg-transparent rounded-[12px] w-[104px] md:w-[144px] md:px-[40px] text-[14px] md:text-[16px] font-medium text-center py-[8px] md:py-[12px] mt-[20px] md:mt-[63px] join-border text-[#000] md:text-[#333] cursor-pointer"
                @click="clickAbout"
              >
                {{ t('home.hero.btnAbout') }}
              </NuxtLink>
            </div>

            <!-- tab切换卡片 -->
            <div
              class="self-center mb-[80px] flex pointer-events-auto relative"
            >
              <!-- 左侧渐变竖线 -->
              <div class="relative mr-[24px]">
                <div class="w-[2px] h-full bg-[#D0D7E6] rounded-full"></div>
                <!-- 渐变指示器 -->
                <div
                  class="absolute left-[-1px] w-[4px] h-[28px] rounded-full transition-all duration-300"
                  :class="
                    selectedHeroIndex === -1 ? 'opacity-0' : 'opacity-100'
                  "
                  style="
                    background: linear-gradient(
                      192deg,
                      #6effcc 0.02%,
                      #003b7f 91%
                    );
                  "
                  :style="{ top: `${selectedHeroIndex * 45}px` }"
                ></div>
              </div>
              <!-- 文字列表 -->
              <div class="flex flex-col gap-[21px]">
                <a
                  v-for="(link, index) in heroLinks"
                  :key="index"
                  :href="link.href"
                  class="min-w-[150px] transition-all cursor-pointer"
                  :class="
                    selectedHeroIndex === index
                      ? 'text-[#2B79A1CC] text-[18px] opacity-1 font-medium'
                      : 'text-[#333333CC] text-[16px] opacity-[0.4] font-nomal'
                  "
                  @click="handleHeroLinkClick(link.action, $event, index)"
                >
                  {{ link.title }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- 向下滚动箭头 -->
        <div
          class="w-[76px] h-[34px] bg-[#F1F1F1B2] rounded-[12px] absolute bottom-[20px] left-1/2 -translate-x-1/2 z-20 cursor-pointer"
          style="backdrop-filter: blur(5px)"
          @click="scrollToAbout"
        >
          <img
            src="@/assets/images/gif/arrow.gif"
            alt="向下滚动箭头"
            class="w-[76px] h-[34px]"
          />
        </div>
      </section>

      <!-- 了解我们 -->
      <section id="about-us" class="max-w-[1200px] h-[580px] mx-auto">
        <div class="mx-auto">
          <div class="flex items-start pt-[80px] gap-[20px]">
            <div class="w-1/2">
              <p class="mb-[22px] text-4xl font-medium text-[#000] md:text-4xl">
                {{ t('home.about.title') }}
              </p>
              <p class="mb-20 text-[21px] leading-relaxed text-[#000]">
                {{ t('home.about.description') }}
              </p>
              <NuxtLink
                :to="`/product/product1000-shanhai`"
                class="bg-[#FFFFFF99] md:bg-transparent rounded-[12px] w-[104px] md:w-[144px] md:px-[40px] text-[14px] md:text-[16px] font-medium text-center py-[8px] md:py-[12px] mt-[20px] md:mt-[63px] join-border text-[#000] md:text-[#333] cursor-pointer"
              >
                {{ t('home.about.btnAbout') }}
              </NuxtLink>
            </div>

            <!-- 图片占位 -->
            <div
              class="mt-[60px] relative aspect-video w-1/2 h-[360px] overflow-hidden rounded-xl"
            >
              <!-- <video
                v-lazy-video
                class="w-full h-[360px] rounded-[12px] object-cover"
                data-src="https://images-cloud.qboson.com/website/1000.mp4"
                poster="@/assets/images/1000bit/1000.png"
                loop
                muted
                playsinline
                disablepictureinpicture
                controlsList="nodownload nofullscreen noremoteplayback"
                oncontextmenu="return false"
              ></video> -->
              <img
                src="https://images-cloud.qboson.com/website/home/1000T-shanhai1.png"
                alt="1000T-山海"
                class="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- sdk掉用量 -->
      <section class="w-full h-[590px] relative overflow-hidden bg-white">
        <div class="relative flex">
          <div class="flex-shrink-0">
            <video
              v-lazy-video
              class="w-full h-full"
              data-src="https://images-cloud.qboson.com/website/round_new.webm"
              loop
              muted
              playsinline
              disablepictureinpicture
              controlsList="nodownload nofullscreen noremoteplayback"
              oncontextmenu="return false"
            ></video>
          </div>

          <div
            class="w-[1200px] pt-[55px] absolute z-10 left-1/2 -translate-x-1/2"
          >
            <div class="gap-12">
              <div class="flex flex-col items-end justify-end">
                <p class="mb-6 text-4xl font-medium text-[#000]">
                  {{ t('home.revolution.title') }}
                </p>
                <p
                  class="mb-[90px] text-right text-[21px] text-[#000] font-normal leading-[34px] w-[662px]"
                >
                  {{ t('home.revolution.description') }}
                </p>

                <div class="flex flex-col gap-[90px]">
                  <div class="w-[662px] flex gap-[150px] justify-end">
                    <div class="w-[240px]">
                      <div
                        class="flex items-center border-b border-slate-200 text-[70px] font-bold text-[#000] pb-[28px]"
                      >
                        <el-statistic
                          :value="outputValue"
                          :precision="1"
                          :value-style="valueStyle"
                        /><span>亿+</span>
                      </div>
                      <div class="pt-[7px] text-[18px] font-normal text-[#000]">
                        {{ t('home.revolution.taskCalls') }}
                      </div>
                    </div>
                    <div class="w-[240px]">
                      <div
                        class="flex items-center border-b border-slate-200 text-[70px] font-bold text-[#000] pb-[28px]"
                      >
                        <el-statistic
                          :value="taskValue"
                          :value-style="valueStyle"
                        /><span>%</span>
                      </div>
                      <div class="pt-[7px] text-[18px] font-normal text-[#000]">
                        {{ t('home.revolution.successRate') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-[18px] text-[#777] font-normal mt-[50px]">{{ t('home.revolution.sdkStatsNoteLine1') }}{{ t('home.revolution.sdkStatsNoteLine2') }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 生态解决方案 -->
      <section class="h-[800px] py-24 bg-[#F9FBFF]">
        <div class="max-w-[1200px] mx-auto px-4 md:px-8">
          <div class="flex flex-col items-center mx-auto mb-16">
            <p class="text-4xl font-medium text-[#000] mb-[15px]">
              {{ t('home.solutions.title') }}
            </p>
            <p class="text-[21px] text-[#000] text-center mb-[40px]">
              {{ t('home.solutions.description') }}
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-[42px]">
            <div
              v-for="(item, index) in solutions"
              :key="index"
              class="flex flex-col items-center bg-white rounded-xl p-10 text-center transition-all hover:shadow-[20px_35px_70px_0px_rgba(0,0,0,0.08)] hover:-translate-y-1 group cursor-default"
            >
              <div
                class="mb-6 inline-flex h-16 w-16 items-center justify-center text-3xl"
              >
                <img :src="item.icon" alt="" />
              </div>
              <h3 class="text-base font-medium text-[#000] mb-[6px]">
                {{ item.title }}
              </h3>
              <p
                class="min-h-[85px] text-[14px] text-[#000] font-normal mb-[18px]"
              >
                {{ item.desc }}
              </p>
              <NuxtLink
                :to="item.link"
                class="bg-[#FFFFFF99] md:bg-transparent rounded-[12px] w-[104px] md:w-[144px] text-[14px] md:text-[14px] font-medium text-center py-[8px] md:py-[12px] join-border text-[#000] md:text-[#333] cursor-pointer"
                @click="clickSolutions(item)"
              >
                {{ item.btnText }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </section>

      <!-- 产品软件集合 -->
      <section class="pt-[52px] pb-[200px] bg-white">
        <div class="max-w-[1200px] mx-auto px-4 md:px-8">
          <div class="mb-[50px]">
            <p class="text-4xl font-bold text-slate-900 mb-6">
              {{ t('home.products.title') }}
            </p>
            <p class="text-[21px] leading-relaxed">
              {{ t('home.products.description') }}
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
            <div v-for="(prod, i) in products" :key="i" class="flex flex-col">
              <!-- Image Placeholder -->
              <div
                class="w-[220px] h-[124px] bg-white rounded-lg shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)] mb-6 overflow-hidden"
              >
                <div
                  class="w-full h-full shadow-[20px_35px_70px_0px_rgba(0,0,0,0.08)] flex items-center justify-center text-slate-300"
                >
                  <img :src="prod.img" alt="" />
                </div>
              </div>

              <h3 class="text-[24px] font-medium text-[#000] mb-[10px]">
                {{ prod.title }}
              </h3>
              <a
                v-if="prod.target !== ''"
                :href="prod.link"
                :target="prod.target"
                class="inline-flex items-center text-[18px] text-[#000] mb-[10px] group"
                @click="trackEventProducts(prod)"
              >
                {{ t('home.products.learnMore') }}
                <span
                  class="ml-1 text-[24px] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  >↗</span
                >
              </a>
              <NuxtLink
                v-else
                :to="prod.link"
                class="inline-flex items-center text-[18px] text-[#000] mb-[10px] group"
                @click="trackEventProducts(prod)"
              >
                {{ t('home.products.learnMore') }}
                <span
                  class="ml-1 text-[24px] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  >↗</span
                >
              </NuxtLink>
              <p class="text-[16px] text-[#666] font-normal">
                {{ prod.desc }}
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 展望图 -->
      <section class="py-[80px] bg-[#F9FBFF] overflow-x-hidden">
        <div class="mx-auto px-4 md:px-8">
          <div class="text-center mb-[55px]">
            <p class="text-4xl font-medium text-[#000] mb-[53px]">
              {{ t('home.roadmap.title') }}
            </p>
            <p class="md:w-[40%] text-[21px] text-[#000] max-w-[902px] mx-auto">
              {{ t('home.roadmap.description') }}
            </p>
          </div>
        </div>

        <!-- 时间轴容器 - 充满整个页面宽度 -->
        <div
          ref="roadmapScrollRef"
          class="relative w-full overflow-x-auto pb-12 no-scrollbar"
        >
          <div class="relative pl-[120px] pr-8" style="min-width: 100%">
            <!-- Items 上半部分：图标、标题、描述 -->
            <div class="flex mb-[10px]">
              <div
                v-for="(milestone, index) in roadmapItems"
                :key="`item-${index}`"
                class="flex-shrink-0 flex flex-col cursor-pointer"
                style="width: calc(100vw / 5)"
                @mouseenter="hoveredColumnIndex = index"
                @mouseleave="hoveredColumnIndex = 1"
              >
                <!-- 图片 -->
                <div
                  class="w-[110px] h-[140px] flex items-center justify-center transition-all mb-[20px]"
                >
                  <img
                    :src="milestone.img"
                    alt=""
                    class="max-w-full max-h-full object-contain"
                  />
                </div>

                <!-- 标题 -->
                <h3
                  class="text-[14px] font-medium text-left transition-colors whitespace-pre-line ml-[3px] mb-[10px] min-h-[63px]"
                  :class="
                    hoveredColumnIndex === index
                      ? 'text-[#1976AC]'
                      : 'text-[#000]'
                  "
                >
                  {{ milestone.title }}
                </h3>

                <!-- 描述 -->
                <div
                  class="flex flex-col items-left justify-start min-h-[80px]"
                >
                  <p
                    v-for="(desc, i) in milestone.descriptions"
                    :key="i"
                    class="text-[14px] text-left ml-[3px] transition-colors"
                    :class="
                      hoveredColumnIndex === index
                        ? 'text-[#1976AC]'
                        : 'text-[#666]'
                    "
                  >
                    {{ desc }}
                  </p>
                </div>
              </div>
            </div>

            <!-- 时间轴层：横线 + 圆点 -->
            <div class="relative flex mb-[16px]">
              <div
                class="absolute top-[6px] h-[2px] bg-[#E5E7EB] z-0"
                :style="{
                  left: '-120px',
                  width: `calc(100vw / 5 * ${roadmapItems.length} + 120px)`,
                }"
              ></div>

              <div
                v-for="(milestone, index) in roadmapItems"
                :key="`dot-${index}`"
                class="flex-shrink-0 flex ml-[3px] cursor-pointer"
                style="width: calc(100vw / 5)"
                @mouseenter="hoveredColumnIndex = index"
                @mouseleave="hoveredColumnIndex = 1"
              >
                <div class="relative z-10">
                  <div
                    class="w-[14px] h-[14px] rounded-full transition-all"
                    :class="
                      hoveredColumnIndex === index
                        ? 'scale-100 shadow-[0_0_12px_rgba(65,224,203,0.6)] bg-gradient-to-b from-[#41E0CB] to-[#043F9B]'
                        : 'bg-[#D9D9D9]'
                    "
                  ></div>
                </div>
              </div>
            </div>

            <!-- Items 下半部分：年份 -->
            <div class="flex">
              <div
                v-for="(milestone, index) in roadmapItems"
                :key="`year-${index}`"
                class="flex-shrink-0 flex cursor-pointer"
                style="width: calc(100vw / 5)"
                @mouseenter="hoveredColumnIndex = index"
                @mouseleave="hoveredColumnIndex = 1"
              >
                <div
                  class="text-[14px] font-medium transition-colors ml-[3px]"
                  :class="
                    hoveredColumnIndex === index ? 'text-[#000]' : 'text-[#000]'
                  "
                >
                  {{ milestone.year }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 改变世界 -->
      <section class="pt-[80px] bg-white">
        <div class="mx-auto">
          <div class="text-center mb-[55px]">
            <p class="text-4xl font-medium text-[#000] mb-[53px]">
              {{ t('home.future.title') }}
            </p>
            <p
              class="md:max-w-[1200px] text-[21px] text-[#000] max-w-[902px] mx-auto"
            >
              {{ t('home.future.description') }}
            </p>
          </div>

          <!-- 恒星模块 -->
          <div class="relative h-[445px] bg-black">
            <!-- ParticleStar 作为背景 -->
            <div class="absolute inset-0 w-full h-full">
              <ClientOnly>
                <ParticleStar />
              </ClientOnly>
            </div>

            <!-- 前景内容 -->
            <div
              class="relative z-10 h-full flex flex-col items-center justify-end"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="762"
                height="287"
                viewBox="0 0 762 287"
                fill="none"
              >
                <path
                  d="M1 285.604C85.6265 282.934 270.242 275.992 331.692 269.583C408.504 261.573 462.871 265.578 625.973 119.386C724.414 31.1504 755.419 4.43047 760.284 1"
                  stroke="url(#paint0_linear_5175_17777)"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_5175_17777"
                    x1="761"
                    y1="0.604255"
                    x2="651.5"
                    y2="106.604"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF0000" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>
              <div
                class="text-white w-[763px] flex justify-between border-t border-[#fff] pt-[13px] mb-[33px]"
              >
                <span class="text-[21px] font-normal leading-[34px]">1980</span>
                <span class="text-[21px] font-normal leading-[34px]">2010</span>
                <span class="text-[21px] font-normal leading-[34px]">2025</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 移动端 -->
    <div class="md:hidden">
      <!-- 头部区域 -->
      <section
        class="relative bg-white h-[712px] pt-[80px] pb-[40px] px-[20px] overflow-hidden"
      >
        <!-- 粒子动效 - 作为背景铺满整个区域 -->
        <div class="absolute inset-0 w-full h-full">
          <ClientOnly>
            <fenziTest
              ref="fenziTestRefMobile"
              :disable-internal-click="true"
              @molecule-click="onMoleculeClick"
              @hover-change="onParticleHoverChange"
            />
          </ClientOnly>
        </div>

        <div class="relative z-10 flex flex-col">
          <p class="text-[24px] font-medium text-[#000] mb-[12px]">
            {{ t('home.hero.title1') }}<br />{{ t('home.hero.title2') }}
          </p>
          <!-- 描述文字带展开/收起功能 -->
          <div class="mb-[20px]">
            <template v-if="!isHeroDescExpanded">
              <div class="relative">
                <p
                  class="max-w-[95%] text-[14px] text-[#2B79A1] text-justify line-clamp-2"
                >
                  {{ t('home.hero.description') }}
                </p>
                <span
                  class="absolute bottom-0 right-0 bg-white pl-[1px] text-[#2B79A1] cursor-pointer inline-flex items-center"
                  @click="isHeroDescExpanded = true"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M13.9831 6C14.2488 6 14.4641 6.04361 14.629 6.13082C14.7939 6.21803 14.9038 6.33299 14.9588 6.47569C15.0137 6.6184 15.0137 6.77895 14.9588 6.95733C14.9038 7.13572 14.7847 7.31212 14.6015 7.48654C13.8595 8.20008 13.1449 8.89777 12.4578 9.5796C11.7708 10.2614 11.1066 10.8996 10.4653 11.4943C10.2913 11.6528 10.0874 11.7757 9.85384 11.8629C9.62024 11.9501 9.37976 11.9957 9.13242 11.9997C8.88507 12.0037 8.64689 11.97 8.41786 11.8986C8.18884 11.8272 7.99646 11.7163 7.84072 11.5656C7.48345 11.2247 7.11243 10.8759 6.72767 10.5191L5.54591 9.44878C5.16115 9.09201 4.77868 8.74118 4.3985 8.39631C4.01832 8.05143 3.66334 7.71646 3.33354 7.3914C3.17781 7.24077 3.07704 7.08419 3.03123 6.92166C2.98543 6.75913 2.99001 6.61047 3.04497 6.47569C3.09994 6.34091 3.20529 6.22992 3.36102 6.14271C3.51676 6.0555 3.7183 6.01189 3.96565 6.01189C4.28628 6.01189 4.72829 6.00991 5.29169 6.00595C5.85509 6.00198 6.47116 6 7.13991 6H9.20112H11.2211H12.9113H13.9831Z"
                      fill="#444444"
                    />
                  </svg>
                </span>
              </div>
            </template>
            <template v-else>
              <span class="text-[14px] text-[#2B79A1] text-justify">
                {{ t('home.hero.description')
                }}<span
                  class="text-[#2B79A1] cursor-pointer inline-flex items-center align-middle ml-[2px]"
                  @click="isHeroDescExpanded = false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="6"
                    viewBox="0 0 12 6"
                    fill="none"
                  >
                    <path
                      d="M10.9831 6C11.2488 6 11.4641 5.95639 11.629 5.86918C11.7939 5.78197 11.9038 5.66701 11.9588 5.52431C12.0137 5.3816 12.0137 5.22105 11.9588 5.04267C11.9038 4.86428 11.7847 4.68788 11.6015 4.51346C10.8595 3.79992 10.1449 3.10223 9.45784 2.4204C8.77077 1.73858 8.1066 1.10035 7.46533 0.505738C7.29128 0.347173 7.08745 0.224286 6.85384 0.137075C6.62024 0.0498648 6.37976 0.00427771 6.13242 0.000313282C5.88507 -0.00365067 5.64689 0.0300441 5.41786 0.101398C5.18884 0.172752 4.99646 0.283747 4.84072 0.434384C4.48345 0.775298 4.11243 1.12414 3.72767 1.48091L2.54591 2.55122C2.16115 2.90799 1.77868 3.25882 1.3985 3.60369C1.01832 3.94857 0.663335 4.28354 0.333541 4.6086C0.177805 4.75923 0.0770352 4.91581 0.0312305 5.07834C-0.0145742 5.24087 -0.00999377 5.38953 0.0449719 5.52431C0.0999375 5.65909 0.205288 5.77008 0.361024 5.85729C0.51676 5.9445 0.718301 5.98811 0.965646 5.98811C1.28628 5.98811 1.72829 5.99009 2.29169 5.99405C2.85509 5.99802 3.47116 6 4.13991 6H6.20112H8.22111H9.9113H10.9831Z"
                      fill="#444444"
                    />
                  </svg>
                </span>
              </span>
            </template>
          </div>
          <NuxtLink
            :to="`/about`"
            class="bg-transparent rounded-[12px] w-[104px] text-[14px] font-medium text-center py-[8px] join-border text-[#000] cursor-pointer"
          >
            {{ t('home.hero.btnAbout') }}
          </NuxtLink>
        </div>

        <!-- 右下角圆点装饰 -->
        <div
          class="absolute bottom-[40px] right-[20px] flex items-center gap-[8px] z-10"
        >
          <!-- 小圆点散布 -->
          <div
            class="absolute -top-[60px] -left-[40px] w-[12px] h-[12px] rounded-full bg-[#B8E4DD] opacity-60"
          ></div>
          <div
            class="absolute -top-[80px] left-[20px] w-[8px] h-[8px] rounded-full bg-[#B8E4DD] opacity-40"
          ></div>
          <div
            class="absolute -top-[40px] left-[80px] w-[6px] h-[6px] rounded-full bg-[#B8E4DD] opacity-50"
          ></div>
          <div
            class="absolute -top-[90px] left-[100px] w-[10px] h-[10px] rounded-full bg-[#B8E4DD] opacity-30"
          ></div>

          <!-- 可点击圆点 -->
          <div
            class="w-[12px] h-[12px] rounded-full cursor-pointer transition-all"
            :class="
              selectedDotIndex === 0
                ? 'dot-active'
                : 'border-[2px] border-[#E8E8E8] bg-transparent'
            "
            @click="handleDotClick(0)"
          ></div>
          <div
            class="w-[12px] h-[12px] rounded-full cursor-pointer transition-all"
            :class="
              selectedDotIndex === 1
                ? 'dot-active'
                : 'border-[2px] border-[#E8E8E8] bg-transparent'
            "
            @click="handleDotClick(1)"
          ></div>
          <div
            class="w-[12px] h-[12px] rounded-full cursor-pointer transition-all"
            :class="
              selectedDotIndex === 2
                ? 'dot-active'
                : 'border-[2px] border-[#E8E8E8] bg-transparent'
            "
            @click="handleDotClick(2)"
          ></div>
          <div
            class="w-[12px] h-[12px] rounded-full cursor-pointer transition-all"
            :class="
              selectedDotIndex === 3
                ? 'dot-active'
                : 'border-[2px] border-[#E8E8E8] bg-transparent'
            "
            @click="handleDotClick(3)"
          ></div>
        </div>
      </section>

      <!-- 了解我们 -->
      <section
        class="flex flex-col items-center bg-[#F9FBFF] py-[40px] px-[20px]"
      >
        <p class="text-[16px] font-medium text-[#000] leading-[16px] mb-[12px]">
          {{ t('home.about.title') }}
        </p>
        <p class="text-center text-[12px] text-[#666666] mb-[23px]">
          {{ t('home.about.description') }}
        </p>
        <!-- 图片占位 -->
        <!-- <div
          class="w-full h-[206px] rounded-[6px] shadow-[10px_17px_35px_0px_rgba(0,0,0,0.08)]"
        >
          <video
            v-lazy-video
            class="w-full h-full rounded-md object-cover"
            data-src="https://images-cloud.qboson.com/website/1000.mp4"
            loop
            muted
            playsinline
            disablepictureinpicture
            controlsList="nodownload nofullscreen noremoteplayback"
            oncontextmenu="return false"
          ></video>
        </div> -->
        <img
          src="https://images-cloud.qboson.com/website/home/1000T-shanhai-mobile.png"
          alt="1000T-山海"
          class="w-full h-[210px] object-contain scale-125 transform"
        />
        <NuxtLink
          :to="`/product/product1000-shanhai`"
          class="mt-[24px] bg-transparent rounded-[12px] w-[104px] text-[14px] font-medium text-center py-[8px] join-border text-[#000] cursor-pointer mb-[24px]"
        >
          {{ t('home.about.btnAbout') }}
        </NuxtLink>
      </section>

      <!-- SDK调用量 -->
      <section
        class="h-[370px] bg-white pt-[40px] px-[20px] relative overflow-hidden"
      >
        <!-- 背景光圈 -->
        <div class="absolute left-0 top-0 w-full opacity-50">
          <video
            v-lazy-video
            class="w-full h-full"
            data-src="https://images-cloud.qboson.com/website/round_mobile_new.webm"
            loop
            muted
            playsinline
            disablepictureinpicture
            controlsList="nodownload nofullscreen noremoteplayback"
            oncontextmenu="return false"
          ></video>
        </div>

        <div class="relative z-10">
          <p
            class="text-[16px] font-medium text-[#000] leading-[16px] mb-[12px]"
          >
            {{ t('home.revolution.title') }}
          </p>
          <p class="text-[12px] text-[#666] mb-[30px]">
            {{ t('home.revolution.description') }}
          </p>

          <!-- 数据统计 -->
          <div class="grid grid-cols-2 gap-[20px]">
            <div>
              <div class="text-[12px] font-normal text-[#000]">
                {{ t('home.revolution.taskCalls') }}
              </div>
              <div class="flex items-end">
                <el-statistic
                  :value="outputValue"
                  :precision="1"
                  :value-style="mobileValueStyle"
                /><span class="text-[20px] font-[700] pb-[10px]">亿+</span>
              </div>
            </div>
            <div>
              <div class="text-[12px] font-normal text-[#000]">
                {{ t('home.revolution.successRate') }}
              </div>
              <div
                class="flex items-end text-[40px] font-bold text-[#000] pb-[32px]"
              >
                <el-statistic
                  :value="taskValue"
                  :value-style="mobileValueStyle"
                /><span class="text-[20px] font-[700] pb-[10px]">%</span>
              </div>
            </div>
          </div>
          <div class="text-[12px] text-[#777] font-normal mt-[-8px]">{{ t('home.revolution.sdkStatsNoteLine1') }}<br />{{ t('home.revolution.sdkStatsNoteLine2') }}</div>
        </div>
      </section>

      <!-- 生态解决方案 -->
      <section class="bg-[#F9FBFF] py-[40px] px-[20px]">
        <div class="text-center mb-[24px]">
          <p
            class="text-[16px] font-medium leading-[16px] text-[#000] mb-[14px]"
          >
            {{ t('home.solutions.title') }}
          </p>
          <p class="text-[12px] text-[#666] mb-[20px]">
            {{ t('home.solutions.description') }}
          </p>
        </div>

        <div class="flex flex-col gap-[10px]">
          <NuxtLink
            v-for="(item, index) in solutions"
            :key="index"
            :to="item.link"
            class="flex items-center justify-between bg-white rounded-[12px] p-[20px] text-center shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)]"
          >
            <div class="flex items-center">
              <div class="mb-[12px] h-[45px] w-[45px] flex-shrink-0">
                <img :src="item.icon" alt="" class="w-full h-full" />
              </div>
              <div class="flex flex-col items-start ml-[10px]">
                <p
                  class="text-[14px] font-medium leading-[16px] text-[#000] mb-[6px]"
                >
                  {{ item.title }}
                </p>
                <p class="text-left text-[12px] text-[#666] font-normal">
                  {{ item.desc }}
                </p>
              </div>
            </div>
            <div class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M8 14L12 10L8 6"
                  stroke="black"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </NuxtLink>
          <!-- <NuxtLink
            :to="`/about`"
            class="mt-[24px] bg-transparent rounded-[12px] w-[104px] text-[14px] font-medium text-center py-[8px] join-border text-[#000] cursor-pointer mx-auto"
          >
            {{ t('home.hero.btnAbout') }}
          </NuxtLink> -->
        </div>
      </section>

      <!-- 产品软件集合 -->
      <section class="bg-white py-[40px] px-[20px]">
        <p
          class="text-center text-[16px] font-medium text-[#000] leading-[16px] mb-[14px]"
        >
          {{ t('home.products.title') }}
        </p>
        <p class="text-center text-[12px] text-[#666] font-normal mb-[26px]">
          {{ t('home.products.description') }}
        </p>

        <div class="flex gap-[10px] overflow-x-auto no-scrollbar">
          <div
            v-for="(prod, i) in products"
            :key="i"
            class="mb-[20px] min-w-[150px] rounded-[4px] w-[150px] flex flex-col flex-shrink-0 shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)]"
          >
            <!-- Image Placeholder -->
            <div class="w-full h-[88px] bg-white mb-[16px]">
              <img :src="prod.img" alt="" class="w-full h-full object-cover" />
            </div>

            <p
              class="pl-[10px] text-[14px] font-medium leading-[16px] text-[#000] mb-[8px]"
            >
              {{ prod.title }}
            </p>
            <p class="h-[72px] pl-[10px] text-[12px] text-[#666] font-normal">
              {{ prod.desc }}
            </p>

            <a
              v-if="prod.target !== ''"
              :href="prod.link"
              :target="prod.target"
              class="pl-[10px] inline-flex items-center font-normal text-[12px] text-[#000] my-[14px]"
            >
              {{ t('home.products.learnMore') }}
              <svg
                class="ml-[4px]"
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="7"
                viewBox="0 0 8 7"
                fill="none"
              >
                <path
                  d="M0.5 3.5H7.5M7.5 3.5L4.5 0.5M7.5 3.5L4.5 6.5"
                  stroke="black"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            <NuxtLink
              v-else
              :to="prod.link"
              class="pl-[10px] inline-flex items-center font-normal text-[12px] text-[#000] my-[14px]"
            >
              {{ t('home.products.learnMore') }}
              <svg
                class="ml-[4px]"
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="7"
                viewBox="0 0 8 7"
                fill="none"
              >
                <path
                  d="M0.5 3.5H7.5M7.5 3.5L4.5 0.5M7.5 3.5L4.5 6.5"
                  stroke="black"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </NuxtLink>
          </div>
        </div>
      </section>

      <!-- 展望图 -->
      <section class="bg-[#F9FBFF] py-[40px] px-[20px] overflow-x-auto">
        <div class="text-center mb-[20px]">
          <p
            class="text-[16px] font-medium leading-[16px] text-[#000] mb-[14px]"
          >
            {{ t('home.roadmap.title') }}
          </p>
          <p class="text-[12px] text-[#666] font-normal">
            {{ t('home.roadmap.description') }}
          </p>
        </div>

        <!-- 时间线 - 可横向滚动 -->
        <div class="overflow-x-auto no-scrollbar">
          <div class="px-[10px] pb-[10px]">
            <!-- 内容列 -->
            <div class="flex gap-[30px]">
              <div
                v-for="(milestone, index) in roadmapItems"
                :key="`item-${index}`"
                class="flex-shrink-0 flex flex-col items-start relative"
              >
                <!-- 图片 -->
                <div
                  class="w-[55px] h-[70px] flex items-center justify-center mb-[16px]"
                >
                  <img
                    :src="milestone.img"
                    alt=""
                    class="max-w-full max-h-full object-contain"
                  />
                </div>

                <!-- 标题 -->
                <h3
                  class="text-[14px] font-medium text-left text-[#000] whitespace-pre-line mb-[10px] min-h-[63px]"
                >
                  {{ milestone.title }}
                </h3>

                <!-- 描述 -->
                <div
                  class="flex flex-col items-start justify-start min-h-[80px] mb-[10px]"
                >
                  <p
                    v-for="(desc, i) in milestone.descriptions"
                    :key="i"
                    class="text-[14px] text-left text-[#666]"
                    :class="
                      desc === '增加新能控制精度（提升运维效率）'
                        ? 'max-w-[120px]'
                        : ''
                    "
                  >
                    {{ desc }}
                  </p>
                </div>

                <!-- 圆点和横线 -->
                <div class="relative w-full mb-[16px]">
                  <!-- 横线 - 从当前圆点延伸到下一个 -->
                  <div
                    class="absolute top-[7px] left-[14px] h-[2px] bg-[#E5E7EB]"
                    style="width: calc(100% + 30px)"
                  ></div>
                  <!-- 圆点 -->
                  <div
                    class="relative z-10 w-[14px] h-[14px] rounded-full shadow-[0_0_12px_rgba(65,224,203,0.6)] bg-gradient-to-b from-[#41E0CB] to-[#043F9B]"
                  ></div>
                </div>

                <!-- 年份 -->
                <div class="text-[14px] font-medium text-[#000]">
                  {{ milestone.year }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 改变世界 -->
      <section class="relative bg-black pt-[40px]">
        <!-- ParticleStar 作为背景 -->
        <div class="absolute inset-0 w-full h-full">
          <ClientOnly>
            <ParticleStar />
          </ClientOnly>
        </div>

        <div class="relative z-10">
          <div class="text-center mb-[24px] px-[16px] pb-[20px]">
            <p
              class="text-[16px] font-medium leading-[16px] text-white mb-[14px]"
            >
              {{ t('home.future.title') }}
            </p>
            <p class="text-[12px] font-normal text-white">
              {{ t('home.future.description') }}
            </p>
          </div>

          <div
            class="flex flex-col items-center justify-end h-[250px] rounded-[12px] px-[16px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="317"
              height="121"
              viewBox="0 0 317 121"
              fill="none"
            >
              <path
                d="M1 120C36.1086 118.884 112.699 115.981 138.192 113.301C170.059 109.952 192.614 111.626 260.279 50.5C301.119 13.6066 313.982 2.43436 316 1"
                stroke="url(#paint0_linear_2682_15838_mobile)"
                stroke-width="2"
                stroke-linecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2682_15838_mobile"
                  x1="316.297"
                  y1="0.834529"
                  x2="270.526"
                  y2="44.7977"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF0000" />
                  <stop offset="1" stop-color="white" />
                </linearGradient>
              </defs>
            </svg>
            <div
              class="text-white w-[317px] flex justify-between border-t-2 border-[#fff] pt-[8px] mt-[14px] mb-[16px]"
            >
              <span class="text-[16px] leading-[34px] font-normal">1980</span>
              <span class="text-[16px] leading-[34px] font-normal">2010</span>
              <span class="text-[16px] leading-[34px] font-normal">2025</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
.join-border {
  position: relative;
  z-index: 1;
}

.join-border::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    rgba(55, 187, 148, 1),
    rgba(1, 46, 128, 1)
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: -1;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 圆点选中状态 */
.dot-active {
  background: linear-gradient(90deg, #36ba93 0%, #47c3e1 50%, #073c89 100%);
}
</style>
